export default class AnalyticsUniqueCustomers {
    uniqueLoggedInCustomers = 0;
    guestCustomers = 0;

}